import React, { useContext, useEffect, useRef, useState } from "react";

import { BoxWrapper } from "../../../style";
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper } from "../../../components/loan/style";
import Button from "../../../components/ui/Button";
import Alert from "../../../components/ui/Alert";

import { useLocation, useNavigate } from "react-router-dom";
import { getStorage, goBack, isEmpty } from "../../../Utils/common";

import PictureUpload from "../../../components/PictureUpload/PictureUpload";

import ContextDashboard from "../../../Context/ContextDashboard";
import { uploadProfilePhoto, getDashboardData } from "../../../Utils/api";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import { ArrowLeft, IdCard } from "lucide-react";

function PanUpload() {
  const [loading, setLoading] = useState(false);
  const [responce, setResponce] = useState({});
  const [image, setImage] = useState("");
  const [base64, setBase64] = useState("");
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  const { message, setMessage, logout, getProfileDaital, setps } =
    useContext(ContextDashboard);

  useEffect(() => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result;
      const data = base64.split(",");
      let img = data[data.length - 1];
      setBase64(img);
    };

    if (image) {
      if (typeof image === "string") {
        const blob = new Blob([image]);
        reader.readAsDataURL(blob);
      } else {
        reader.readAsDataURL(image);
      }
    }
  }, [image]);

  const submit = () => {
    if (image === "" && base64 === "") {
      setMessage({
        type: "error",
        msg: "Please select  pan image",
        place: "local",
      });
      return;
    } else {
      setMessage({});
    }
    let ext = "JPEG";
    if (typeof image === "object") {
      let extArr = image.name.split(".");
      ext = extArr[extArr.length - 1].toUpperCase();
    }

    const param = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      file: base64,
      ext: ext,
      password: "N/A",
      docs_id: "4",
    };

    setLoading(true);
    uploadProfilePhoto(param).then((resp) => {
      setLoading(false);
      console.log(resp?.data);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "globle",
        });
        getProfileDaital();
        navigate("/my-dashboard/bank-upload");
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });
  };
  useEffect(() => {

    const params = {
      lead_id: getStorage("lead_id") || "",
      token: getStorage("token") || "",
      mobile: getStorage("mobile") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data?.Steps?.data || {};
        if (dashboardData) {

          setProgressBar(resp?.data?.Steps?.steps?.step_complete_percent);
        }
      } else if (resp?.data?.Status === 5) {
        logout();
      }
    });
  }, [logout]);

  useEffect(() => {
    if (!isEmpty(setps)) {
      checkStep(setps);
    }
  }, [setps]);

  const checkStep = (data) => {
    const steps = (data?.step_stage - 1);
    if (data?.step_complete_percent === 100) {
      setToggle(false);
    }
    setShowSteps(steps);
  };

  return (
    <><ProgressBar value={`${progressBar}%`}>

      <div >
      </div>
      <></>
    </ProgressBar>
      <br />
      {/* <BoxWrapper className="w100">
      <div className="formmainBox flex">
        <div className="left">
          <div
            className="center gap4 pointer"
            onClick={() => goBack(navigate, "/my-dashboard/adhar-upload")}
          >
            <img src={arrowIcon} alt="" /> <span>Back</span>
          </div>
        </div>
        <div className="right">
          <h2>Upload Your PAN <span style={{color:"red"}}>*</span></h2>
          <p>Upload your PAN to verify your details</p>

          <FormWrapper>
            <Alert setMessage={setMessage} message={message} />

            <div className="inputBox">
              <div>
            <h2 className='subheading small'>Pan card</h2>
              <PictureUpload setImage={setImage} image={image} />
              </div>
            </div>

            <div className="button">
              <Button
                title={state?.action ? "Update" : "Continue"}
                onClick={submit}
                loading={loading}
              />
            </div>
          </FormWrapper>
        </div>
      </div>
    </BoxWrapper> */}

      <BoxWrapper className="w-full">
        <div className="flex flex-col gap-6">

          {/* Back Button */}
          <div>
            <div
              className="inline-flex items-center gap-2 px-5 py-2 border border-blue-500 rounded-lg cursor-pointer text-blue-600 font-medium hover:bg-blue-50 transition-all duration-300 group"
              onClick={() => goBack(navigate, "/my-dashboard/adhar-upload")}
            >
              <ArrowLeft size={18} className='inline w-4 mr-1 text-blue-600 group-hover:-translate-x-1 transition-all duration-300' />
              <span>Back</span>
            </div>
          </div>

          {/* Main Card */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-8">

            <h2 className="text-3xl font-bold text-[#1B2A57]">
              Upload Your PAN <span className="text-red-500">*</span>
            </h2>

            <p className="mt-2 text-gray-500 text-base">
              Upload your PAN to verify your details.
            </p>

            <FormWrapper>
              <Alert setMessage={setMessage} message={message} />

              <div className="mt-8">
                <div className="w-full max-w-full rounded-2xl border border-gray-200 shadow-sm p-4 sm:p-6">
                  <h2 className="text-lg sm:text-xl font-bold text-[#1B2A57] mb-4">
                    PAN Card
                  </h2>

                  <PictureUpload
                    setImage={setImage}
                    image={image}
                  />
                </div>
              </div>

              <div className="button mt-8">
                <Button
                  title={state?.action ? "Update" : "Continue"}
                  onClick={submit}
                  loading={loading}
                />
              </div>

            </FormWrapper>

          </div>
        </div>
      </BoxWrapper>
    </>
  );
}

export default PanUpload;